import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
// import { MarginService } from 'src/app/service/margin.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { config } from 'src/app/valueObject/config';
import { throwError, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { Subscription, timer } from 'rxjs';
// import { NcmsService } from 'src/app/service/ncms.service';
import { HttpHeaders } from '@angular/common/http';
import { SseClient } from 'ngx-sse-client';
import { environment } from 'src/environments/environment';
declare var $: any;
//import { UserDetailsService } from 'src/app/service/user-details.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {

  selectedIndex = -1;
  tmEnableData: any = [];
  tmLimitData: any;
  marginSummary: any = {};
  userDetails: any = {};
  status: boolean = false;
  config: any = config;
  subscription: Subscription;
  user: any = []
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  tmEnableMenu: any = {};
  tmLimitMenu: any = {};
  tradeInquiryMenu:any={};
  giveUpMenu:any={}
  marginMenu: any = {};
  pendingTrades:any = [];
  rejectedTrades:any = [];
  approvedTrades: any = [];
  subscription1: Subscription;
  dtOptions: any = {};
  dtOptions1: any = {};
  constructor(
    // private marginService: MarginService,
    private userDetailsService: UserDetailsService,
    private toastr: ToastrService,
    private titleService: Title,
    // private ncmsService: NcmsService,
    private sseClient: SseClient,
    private cdref: ChangeDetectorRef
    //private userDetailsService: UserDetailsService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      orderCellsTop: true,
      responsive: true,
      processing: true,
      //dom: 'Blrtip',
      //pagingType: 'full_numbers',      
      pageLength: 5,
  
    }
    this.dtOptions1 = {
      orderCellsTop: true,
      responsive: true,
      processing: true,
      //dom: 'Blrtip',
      //pagingType: 'full_numbers',      
      pageLength: 5,
  
    }
    // this.getTradeSummary();
    this.titleService.setTitle('Home')
    this.userDetails = this.userDetailsService.getUserDetails()
   
  }
  getTradeSummary(){
    
  }

  getTmEnableData() {
   
  }


  getTMMargin() {

    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    this.subscription1 = this.sseClient.stream((environment.SSEURL + this.config.URL.tmMarginURL), { reconnectionDelay: 30000 }, { headers }, 'GET').subscribe((event) => {
      $("#tmLimitSetup").DataTable().destroy();
      if (event.type == 'error') {
        const errorEvent = event as ErrorEvent;
        if (errorEvent.error) {
          this.tmLimitData = [];
          this.dtTrigger.next(true);
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        }
      }
        else {
          const messageEvent = event as MessageEvent;
          var response = JSON.parse(messageEvent.data);
          if (response.statusCode == 200) {
            this.tmLimitData = response.data[0];
            this.dtTrigger.next(true);
          }else{
            this.tmLimitData = [];
            this.dtTrigger.next(true);
            this.toastr.error(response.message);
          }
          
        }
      
    })



    
    // $("#tmLimitSetup").DataTable().destroy();
    // this.marginService.getTMMargin().pipe(
    //   catchError((error: any) => {
    //     this.tmLimitData = [];
    //     this.dtTrigger.next(true);
    //     //this.setSearchFunction();
    //     // this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
    //     if (error.status != 200) {
    //       return throwError(error.error);
    //     }
    //   })
    // ).subscribe((response: any) => {
    //   if (response.statusCode == 200) {
    //     this.tmLimitData = response.data[0];
    //     //this.marginService.addTmLimit(this.tmLimitData)
    //     this.dtTrigger.next(true);
    //     //this.setSearchFunction();
    //   }
    //   else {
    //     this.tmLimitData = [];
    //     this.dtTrigger.next(true);
    //     //this.setSearchFunction();
    //     this.toastr.error(response.message);
    //   }
    // });
 }

  getMarginSummary() {
   
  }

  startResendTimer() {
    const source = timer(90 * 1000, 90 * 1000);
    this.subscription = source.subscribe(val => {
      this.getMarginSummary();
    })
    this.subscription1 = source.subscribe(val => {
      this.getTMMargin();
    })
  }

  clickEvent(id: any) {
    this.status = !id;
  }

  showDiv(index: number) {
    this.selectedIndex = index;
  }

  // doughnutChartLabels: Label[] = ['Approve', 'Reject', 'Pending'];
  // doughnutChartData: MultiDataSet = [
  //   [53, 40, 7]
  // ];
  // segmentShowStroke: false;
  // doughnutChartType: ChartType = 'doughnut';
  // public doughnutChartLegend: boolean = false;

  // colors: Color[] = [
  //   {
  //     backgroundColor: [
  //       '#0E62FF',
  //       '#FFB844',
  //       '#FC5A6B'
  //     ],
  //     borderWidth: [0, 0, 0, 0]
  //   }

  // ];

  // horizontal 
  // public barChartOptions: ChartOptions = {
  //   responsive: true,
  //   legend: { position: 'top' }

  // };
  // public barChartType: ChartType = 'horizontalBar';
  // public barChartLegend = true;
  // public barChartData: ChartDataSets[] = [
  //   { data: [50, 77], label: 'Confirm', stack: 'a', barThickness: 30, },
  //   { data: [17, 20], label: 'Reject', stack: 'a', barThickness: 30, },
  // ];
  // public barChartLabels: string[] = ['Fixed Deposit', 'EPI Funds',];
  // barChartColors: Color[] = [
  //   { backgroundColor: '#0E62FF' },
  //   { backgroundColor: '#FC5A6B' },
  // ]

  //horizontal

  // public barChartOptionsepi: ChartOptions = {
  //   responsive: true,


  // };
  // public barChartTypeepi: ChartType = 'horizontalBar';
  // public barChartLegendepi = true;

  // public barChartDataepi: ChartDataSets[] = [
  //   { data: [50, 77, 90], label: 'Addition', stack: 'a', barThickness: 30, },
  //   { data: [17, 20, 15], label: 'Release', stack: 'a', barThickness: 30, },
  // ];
  // public barChartLabelsepi: string[] = ['Cash Deposit', 'GSEC', 'EPI Funds',];
  // barChartColorsepi: Color[] = [
  //   { backgroundColor: '#0E62FF' },
  //   { backgroundColor: '#0BC9A7' },
  // ]

  ngOnDestroy() {
      this.subscription?.unsubscribe();
      this.subscription1?.unsubscribe();
  }
 
}

